<div class="radio-control">
    @for (option of options(); track option) {
    <label class="radio-control__option" kui-action>
        <input type="radio" name="video-types" [value]="option.value" [ngModel]="type"
            (ngModelChange)="handleModelChange($event)" />
        <span>{{option.name}}</span>
    </label>
    }
</div>